import { render } from "./app-dialog.vue?vue&type=template&id=fc2f6c7c"
import script from "./app-dialog.vue?vue&type=script&lang=js"
export * from "./app-dialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__